import { ReactElement } from 'react';
import styles from './placeholder.module.scss';
import { Image } from '@utmb/design-system/image/Image';
import { CloudinaryTransformEnum } from '@utmb/types/cloudinary-transform.enum';
import { pIdToCloudinary } from '@utmb/utils/cloudinary';
import { ButtonRemake } from '@utmb/design-system/button-remake/ButtonRemake';
import { Font } from '@utmb/design-system/text/font';
import { getColorStyle } from '@utmb/utils/colors';
import { ColorTypesEnum } from '@utmb/types/colors';

interface PlaceholderProps {
    image: string;
    cta: {
        action: string | (() => void);
        label: string;
    };
    variant: 'small' | 'big';
    logo?: string;
    logoHeight?: string;
    title?: string;
    description?: string;
    blank?: boolean;
    children?: React.ReactNode;
}

export function Placeholder({ image, cta, variant, title, description, logo, logoHeight, blank, children }: PlaceholderProps): ReactElement {
    return (
        <div className={styles.placeholder + ' ' + (variant === 'big' ? styles.bigPlaceholder : styles.smallPlaceholder)}>
            <Image
                className={styles.image}
                objectFit="cover"
                image={pIdToCloudinary(image, 'Placeholder background')}
                addOptions={[CloudinaryTransformEnum.TRIM]}
                maxWidth={1920}
                objectPosition={'center'}
            />
            <div className={styles.content}>
                {logo ? (
                    <div className={styles.wrapLogo} style={{ height: logoHeight ? logoHeight : '100px' }}>
                        <Image className={styles.logo} objectFit="contain" width={150} height={150} image={pIdToCloudinary(logo, 'Placeholder logo')} />
                    </div>
                ) : null}

                {title ? (
                    <Font.FuturaBold color={getColorStyle(ColorTypesEnum.WHITE)} className={styles.title} desktop="20" mobile="200">
                        {title}
                    </Font.FuturaBold>
                ) : null}

                {children ? children : null}

                {description ? (
                    <Font.FuturaMedium color={getColorStyle(ColorTypesEnum.WHITE)} className={styles.description} desktop="16" mobile="16">
                        {description}
                    </Font.FuturaMedium>
                ) : null}

                <ButtonRemake customClassName={styles.button} action={cta.action} label={cta.label} variant="solid" target={blank ? '_blank' : '_self'} />
            </div>
        </div>
    );
}
